module.exports = __webpack_public_path__ + "img/partner_img11.4d54c751.png";